import { computed, inject, Injectable, Injector, signal } from '@angular/core';
import { WorkflowDraftConfirmationService } from '../../workflow-registry-diagnostics/workflow-draft-confirmation.service';
@Injectable({ providedIn: 'root' })
export class RecurringScheduleStateService {
  private readonly injector = inject(Injector);
  private readonly dirty = signal(false);
  private readonly busy = signal(false);
  readonly isDirty = this.dirty.asReadonly();
  readonly isOperationInProgress = this.busy.asReadonly();
  readonly isNavigationBlocked = computed(() => this.dirty() || this.busy());
  setDirty(value: boolean): void {
    this.dirty.set(value);
  }
  setOperationInProgress(value: boolean): void {
    this.busy.set(value);
  }
  confirmNavigation(): boolean | Promise<boolean> {
    if (this.busy()) return false;
    if (!this.dirty()) return true;
    return this.injector
      .get(WorkflowDraftConfirmationService)
      .confirm({
        heading: 'Leave recurring schedules?',
        message:
          'Unsaved schedule changes and entered recovery reasons will be lost if you leave this page.',
        confirmText: 'Leave without saving',
        cancelText: 'Stay on page',
      });
  }
}
